// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pslayout-box{
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: -webkit-fill-available;
  height: 100%;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 18px;
  padding: 20px;
}

.pslayout-header{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.pslayout-header-link{
  text-decoration: none;
  font-weight: bold;
  width: 100%;
}

.pslayout-header-button{
  background-color: var(--bg-card);
  color: var(--text-primary);
  border-radius: 8px;
  font-size: 14px;
  padding: 10px 10px;
  font-weight: 400;
  width: -webkit-fill-available;
  text-align: center;
}

.pslayout-header-button-selected{
  background-color: var(--primary);
  color: white;
  border-radius: 8px;
  font-size: 14px;
  border: solid 1px var(--primary);
  padding: 10px 10px;
  font-weight: bold;
  width: -webkit-fill-available;
  text-align: center;
}

.psform-preview-box{
  width: 200px;
}

.psform-preview-img{
  border-radius: 10px;
  width: 100%;
}

.playlist_builder_search_box {
  display: flex;
  flex-direction: column;
  width: 60%;
  gap: 20px;
}
.playlist_builder_search_input_box{
  border-radius: 5px;
  border: solid 1px var(--border);
  padding: 10px 10px;
  width: 70%;
}
.playlist_builder_details_box {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 5px 5px;
  width: 40%;
  position: relative;
}
.playlist_builder_selected_item_ticker {
  display: flex;
  flex-direction: column;
}

.playlist_builder_selected_item {

}

.playlist_builder_ticker_desc{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.playlist_builder_ticker_desc_end{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.playlist_builder_submit_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin-top: 30px;
}

.playlist_builder_submit_button_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin-top: 30px;
}

.playlist_builder_alert_label{
  color: var(--danger);
}

.playlist_builder_submit {
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
  border: solid 1px var(--primary);
  padding: 10px 10px;
  font-weight: bold;
  text-align: center;
}

.playlist_builder_submit:disabled {
  background-color: #6f94f3;
  border: solid 1px #6f94f3;
}

.playlist_builder_color_picker_row{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  gap: 20px;
  width: 70%;
}

.playlist_builder_color_picker {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/pages/playlists/builder/playlistBuilder.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".pslayout-box{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: -webkit-fill-available;\n  height: 100%;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 18px;\n  padding: 20px;\n}\n\n.pslayout-header{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.pslayout-header-link{\n  text-decoration: none;\n  font-weight: bold;\n  width: 100%;\n}\n\n.pslayout-header-button{\n  background-color: var(--bg-card);\n  color: var(--text-primary);\n  border-radius: 8px;\n  font-size: 14px;\n  padding: 10px 10px;\n  font-weight: 400;\n  width: -webkit-fill-available;\n  text-align: center;\n}\n\n.pslayout-header-button-selected{\n  background-color: var(--primary);\n  color: white;\n  border-radius: 8px;\n  font-size: 14px;\n  border: solid 1px var(--primary);\n  padding: 10px 10px;\n  font-weight: bold;\n  width: -webkit-fill-available;\n  text-align: center;\n}\n\n.psform-preview-box{\n  width: 200px;\n}\n\n.psform-preview-img{\n  border-radius: 10px;\n  width: 100%;\n}\n\n.playlist_builder_search_box {\n  display: flex;\n  flex-direction: column;\n  width: 60%;\n  gap: 20px;\n}\n.playlist_builder_search_input_box{\n  border-radius: 5px;\n  border: solid 1px var(--border);\n  padding: 10px 10px;\n  width: 70%;\n}\n.playlist_builder_details_box {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 5px 5px;\n  width: 40%;\n  position: relative;\n}\n.playlist_builder_selected_item_ticker {\n  display: flex;\n  flex-direction: column;\n}\n\n.playlist_builder_selected_item {\n\n}\n\n.playlist_builder_ticker_desc{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.playlist_builder_ticker_desc_end{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n\n.playlist_builder_submit_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: -webkit-fill-available;\n  margin-top: 30px;\n}\n\n.playlist_builder_submit_button_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: -webkit-fill-available;\n  margin-top: 30px;\n}\n\n.playlist_builder_alert_label{\n  color: var(--danger);\n}\n\n.playlist_builder_submit {\n  background-color: var(--primary);\n  color: white;\n  border-radius: 5px;\n  border: solid 1px var(--primary);\n  padding: 10px 10px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.playlist_builder_submit:disabled {\n  background-color: #6f94f3;\n  border: solid 1px #6f94f3;\n}\n\n.playlist_builder_color_picker_row{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  gap: 20px;\n  width: 70%;\n}\n\n.playlist_builder_color_picker {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
